var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "https:_www.flaticon.com_free-icon_exercise_1934493_term_fitness_20gym_page_3_position_49",
    "data-name": "https://www.flaticon.com/free-icon/exercise_1934493#term=fitness%20gym&page=3&position=49",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.16,
    height: 90.16,
    viewBox: "0 0 90.16 90.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M24.917,49.065l.241,2.9c.441-.036.883-.055,1.333-.055h1.454V49H26.492C25.963,49,25.436,49.022,24.917,49.065Z",
    transform: "translate(9.863 20.801)",
    fill: "#ff1414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M14.184,59.839l2.641,1.216a16.185,16.185,0,0,1,10.543-8.827l-.727-2.817A18.858,18.858,0,0,0,14.184,59.839Z",
    transform: "translate(4.988 20.988)",
    fill: "#ff1414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M72.256,65.7V59.168h8.725V57.714a7.279,7.279,0,0,0-7.271-7.271H72.535a8.64,8.64,0,0,0,.826-.973A9.4,9.4,0,0,0,75,42.174L72.555,29.126a13.091,13.091,0,0,0-8.571-9.944A10.178,10.178,0,1,0,50.6,18.45H38.809V17a4.363,4.363,0,1,0-8.725,0v1.456h-.73a5.088,5.088,0,0,0-.013,10.175h.743V38.809H18.45L12.3,15.542H8.776A7.776,7.776,0,0,0,1.343,25.6L6.871,43.564l8.647,34.585a24.547,24.547,0,0,0-2.884,11.556V91.16H91.16V89.706a24.744,24.744,0,0,0-18.9-24Zm-2.908-.534a24.923,24.923,0,0,0-2.908-.186V59.168h2.908Zm-12.541-6H63.53v5.817H55.56Zm16.9-5.817a4.371,4.371,0,0,1,4.114,2.908H57.43l.624-2.908H73.71ZM50.443,11.179a7.271,7.271,0,1,1,7.271,7.271A7.279,7.279,0,0,1,50.443,11.179ZM32.992,17A1.454,1.454,0,1,1,35.9,17v1.456H32.992ZM27.176,23.54a2.183,2.183,0,0,1,2.178-2.18H59.691a10.186,10.186,0,0,1,10.006,8.3l2.447,13.049A6.526,6.526,0,0,1,71,47.77a6.812,6.812,0,0,1-5.577,2.673H58.052a2.927,2.927,0,0,0-2.844,2.3L51.833,68.5a2.923,2.923,0,0,1-2.843,2.3,2.975,2.975,0,0,1-.6-.063,2.91,2.91,0,0,1-2.239-3.458l3.375-15.756a8.781,8.781,0,0,1,8.491-6.894l1.765-.009L56.7,29.229a4.374,4.374,0,0,0-4.277-3.508H29.341a2.172,2.172,0,0,1-2.165-2.18ZM43.663,64.985H37.355A24.54,24.54,0,0,0,24.812,68.44L19.585,47.534H31.538a7.279,7.279,0,0,0,7.271-7.271V28.628H52.422A1.454,1.454,0,0,1,53.845,29.8l2.414,12.064a11.722,11.722,0,0,0-9.582,9.051ZM30.084,41.717a2.911,2.911,0,0,0,2.908-2.908V28.628H35.9V40.263a4.368,4.368,0,0,1-4.363,4.363h-16V41.717ZM3.908,23.316A4.872,4.872,0,0,1,8.776,18.45h1.287l5.43,20.359H12.634v2.908H9.344L4.122,24.746a4.884,4.884,0,0,1-.214-1.429Zm6.224,21.31h2.5v2.908h3.955L22.25,70.179A24.806,24.806,0,0,0,17.678,74.8ZM15.59,88.252A21.843,21.843,0,0,1,37.355,67.893h5.823a5.8,5.8,0,0,0,4.6,5.69,5.82,5.82,0,0,0,6.9-4.472l.262-1.219h11.5A21.843,21.843,0,0,1,88.2,88.252Z",
    transform: "translate(-1 -1)",
    fill: "#ff1414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M45,53H33.363a4.363,4.363,0,0,0,0,8.725H45A4.363,4.363,0,0,0,45,53Zm0,5.817H33.363a1.454,1.454,0,0,1,0-2.908H45a1.454,1.454,0,0,1,0,2.908Z",
    transform: "translate(11.717 22.618)",
    fill: "#ff1414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M52.817,51a5.817,5.817,0,1,0,5.817,5.817A5.823,5.823,0,0,0,52.817,51Zm0,8.725a2.908,2.908,0,1,1,2.908-2.908A2.911,2.911,0,0,1,52.817,59.725Z",
    transform: "translate(19.893 21.71)",
    fill: "#ff1414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwo);
export default __webpack_public_path__ + "static/media/iconTwo.c4a826b219fbf8c40f4d7eedaef03523.svg";
export { ForwardRef as ReactComponent };